import { render, staticRenderFns } from "./arrowbtn.vue?vue&type=template&id=39dafcfd"
import script from "./arrowbtn.vue?vue&type=script&lang=js"
export * from "./arrowbtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports